import { render, staticRenderFns } from "./SingleSelectOptimized.vue?vue&type=template&id=72c88ba2&scoped=true"
import script from "./SingleSelectOptimized.vue?vue&type=script&lang=js"
export * from "./SingleSelectOptimized.vue?vue&type=script&lang=js"
import style0 from "./SingleSelectOptimized.vue?vue&type=style&index=0&id=72c88ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c88ba2",
  null
  
)

export default component.exports